import type { UnitKind, TowerKind } from "@empire/core-sim";

/** Art milestones only: never affect building stats, costs or prerequisites. */
export function buildingTier(level: number): 1 | 2 | 3 {
  return level >= 10 ? 3 : level >= 5 ? 2 : 1;
}

export function buildingFrame(id: string, level: number): string {
  return level < 1 ? "plot" : buildingTier(level) === 1 ? id : `${id}_tier${buildingTier(level)}`;
}

/** Distance per rigged walk cycle, calibrated to stance travel and wheel circumference. */
export const STRIDE: Record<UnitKind, number> = {
  militia: 540,
  shieldbearer: 410,
  rider: 460,
  ram: 820,
  priest: 476,
  saboteur: 550,
  scout: 660,
};

/** Slightly stronger infantry silhouettes without enlarging their collision radius. */
export const TROOP_SIZE: Record<UnitKind, number> = {
  militia: 1.08,
  shieldbearer: 1.06,
  rider: 1.04,
  ram: 1,
  priest: 1.04,
  saboteur: 1.06,
  scout: 1.08,
};

/** Weapon and base share the same scale, including during recoil and reset. */
export function towerScale(kind: TowerKind, topDown: boolean): number {
  const scale: Record<TowerKind, number> = {
    arrow: 0.78,
    ballista: 0.74,
    cannon: 0.78,
    brazier: 0.72,
    frost: 0.72,
  };
  return scale[kind] * (topDown ? 1.16 : 1);
}
